import { useMagicPenStore } from '@src/stores';

export interface TextColorTracker {
  last: string;
  wasChanged: boolean;
  lastTrigger: number;
}

export const setupColorTracking = (
  textEditorInput: HTMLTextAreaElement
): { unsubscribe: () => void; textColorTracker: TextColorTracker } => {
  const currentStoreState = useMagicPenStore.getState();

  const textColorTracker: TextColorTracker = {
    last: currentStoreState.brushColor,
    wasChanged: false,
    lastTrigger: currentStoreState.colorUpdateTrigger,
  };

  const unsubscribe = useMagicPenStore.subscribe((state) => {
    const newColor = state.brushColor;
    const triggerChanged = state.colorUpdateTrigger !== textColorTracker.lastTrigger;

    // Only apply color if user actively clicked a color picker button
    if (triggerChanged) {
      textEditorInput.style.color = newColor;
      textColorTracker.last = newColor;
      textColorTracker.wasChanged = true;
      textColorTracker.lastTrigger = state.colorUpdateTrigger;
    }
  });

  return { unsubscribe, textColorTracker };
};
